import { useCallback } from 'react';
import { Channel, loadingManager, useChannelContext } from 'scbk-services';
import { useAstxContext } from '../providers/AstxKeypadProvider';

/**
 * Astx 설치 여부 확인 hook
 * @param
 * @returns
 */
const useAstxIsInstall = () => {
  const { channel } = useChannelContext();
  const { isInstalled } = useAstxContext();

  const astxIsInstall = useCallback(
    async (isNeedLoading: boolean = false) => {
      isNeedLoading && loadingManager.open();

      let result: boolean | '' = false;

      if (typeof window === 'undefined') {
        return result;
      }

      if (channel !== Channel.IB) {
        return result;
      }

      if (!(window.$ASTX2 && typeof window.$ASTX2.init === 'function')) {
        return result;
      }

      if (isInstalled) {
        result = true;
        return true;
      }

      result = await new Promise<boolean | ''>((resolve) => {
        // onSuccess 콜백 함수
        const onSuccess = (result: any) => {
          console.log('init 성공: ', JSON.stringify(result, null, 2));
          // ********************* 설치 check 완료 **************************//
          isNeedLoading && loadingManager.close();
          resolve(true);
        };

        // onFailure 콜백 함수
        const onFailure = async (error: unknown) => {
          isNeedLoading && loadingManager.close();
          console.log('init 실패:', JSON.stringify(error, null, 2));
          // console.log('init 실패 window.$ASTX2 : ', window.$ASTX2);
          // console.log(
          //   'init 실패 typeof window.$ASTX2.getLastError: ',
          //   typeof window.$ASTX2.getLastError,
          // );

          // resolve(false);

          if (window.$ASTX2 && typeof window.$ASTX2.getLastError === 'function') {
            let errno = await window.$ASTX2.getLastError();
            if (errno == window.$ASTX2_CONST.ERROR_NOTINST) {
              // goto install page
              // ********************* 진짜 미설치 **************************//
              resolve(false);
            } else {
              // error handling
              resolve(false);
            }
          }
        };

        window.$ASTX2.setOption({ e2eform: false });
        if (window.$ASTX2.init) {
          // init 함수에 콜백 인자 전달
          window.$ASTX2.init(onSuccess, onFailure);
        }
      });

      return result;
    },
    [channel],
  );
  return { astxIsInstall };
};

export { useAstxIsInstall };
